import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/ui/Icon";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { Body, IconBadge, Title, Message, Actions } from "./DeleteAddressModal.styles";

interface DeleteAddressModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteAddressModal({ isOpen, onClose, onConfirm }: DeleteAddressModalProps) {
  const desktop = useIsDesktopViewport();

  return (
    <BottomSheet open={isOpen} onClose={onClose} centered={desktop} maxHeight="48%">
      <Body>
        <IconBadge>
          <Icon name="pin" size={24} strokeWidth={2} />
        </IconBadge>
        <Title>Deletar Endereço</Title>
        <Message>Deseja realmente remover o endereço ?</Message>
        <Actions>
          <Button variant="ghost" full onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" full onClick={onConfirm}>
            Deletar
          </Button>
        </Actions>
      </Body>
    </BottomSheet>
  );
}
